// extracted by mini-css-extract-plugin
export var menu = "Menu-module--menu--3SbXJ";
export var menu__list = "Menu-module--menu__list--WI1fI";
export var menu__list_item = "Menu-module--menu__list_item--3dE8O";
export var menu__list_item_link = "Menu-module--menu__list_item_link--2cg9q";
export var menu__list_item_link__active = "Menu-module--menu__list_item_link__active--c0HxE";